import React from 'react';
import { Container } from 'semantic-ui-react';
import { generateSource } from '../helpers/video';
import { toSnakeCase } from '../helpers/common';

const YouTubePlayer = (props) => {
  const { module } = props;
  const { anchorTagLinkText, source, videoId, title } = module;

  const videoUrl = generateSource(source, videoId);

  return (
    <section
      className="video"
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container>
        <div className="grid-wrapper">
          <div className="video__wrapper">
            {videoUrl ? (
              <iframe title={title} className="video__iframe" src={videoUrl} showinfo="0" controls="0" autohide="1" allow="autoplay; encrypted-media" frameBorder="0" /> /* eslint-disable-line */ 
            ) : (
              'unable to genrate video from source'
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default YouTubePlayer;
